import { Link, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import usePageMeta from "../../usePageMeta";
import "./NotFound.css";

export default function NotFound() {
  const { pathname } = useLocation();

  usePageMeta({
    title: "Page not found | Diarmuid Hession",
    description: "This page doesn't exist. Go back to Diarmuid Hession's portfolio.",
    path: pathname,
    noindex: true,
  });

  return (
    <main className="nf">
      <div className="container">
        <p className="nf-code">404</p>
        <h1 className="nf-title">That page doesn't exist</h1>
        <p className="nf-text">
          There's nothing at <code>{pathname}</code>. It may have moved, or the link has a typo.
        </p>
        <Link to="/" className="btn-brand">
          <FaArrowLeft aria-hidden="true" /> Back to the portfolio
        </Link>
      </div>
    </main>
  );
}
